import { Review } from "../../../Models/Review";
import { BaseAPICallsHandler } from "../BaseAPICallsHandler";
import { NetworkUtils } from "../NetworkUtils";
import { ServerConfig } from "../ServerConfig";

export class ReviewAPIHandler {

  public static shared = new ReviewAPIHandler()

  apiHandler = BaseAPICallsHandler.shared
  serverConfig = ServerConfig.shared
  networkUtils = NetworkUtils.shared

  // dependency injection here
  constructor();
  constructor(apiHandler: BaseAPICallsHandler, serverConfig: ServerConfig, networkUtils: NetworkUtils);
  public constructor(...params: any[]) {
    if (params.length >= 3) {
      this.apiHandler = params[0];
      this.serverConfig = params[1];
      this.networkUtils = params[2];
    }
  };

  public async createReview(reviewData: any): Promise<Notification> {
    const url = this.serverConfig.ReviewAPIs.createReviewAPI + reviewData.gigId;
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makePostRequest(authHeaders, url, reviewData);
      const { review } = response.data;
      const review_ = new Notification(review);
      return Promise.resolve(review_);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getReviewsByGig(gigId: string, pageNumber: number, pageSize: number = 20): Promise<Review[]> {


    let queryParams = new URLSearchParams();
    queryParams.append('pageNumber', pageNumber.toString());
    queryParams.append('pageSize', pageSize.toString());

    const url = this.serverConfig.ReviewAPIs.getReviewsByGigAPI(gigId) + `?${queryParams.toString()}`;
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makeGetRequest(authHeaders, url);
      const reviewsRes = response.data.reviews;
      const reviews = reviewsRes.map((item: any) => new Review(item))
      return Promise.resolve(reviews);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getReviewsByReviewer(gigId: string): Promise<Review[]> {
    const url = this.serverConfig.ReviewAPIs.getReviewsByReviewerAPI(gigId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makeGetRequest(authHeaders, url);
      const reviewsRes = response.data.reviews;
      const reviews = reviewsRes.map((item: any) => new Review(item))
      return Promise.resolve(reviews);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async updateReview(id: string, reviewData: any): Promise<Review> {
    const url = this.serverConfig.ReviewAPIs.updateReviewAPI(id);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makePutRequest(authHeaders, url, reviewData);
      const { updatedReview } = response.data;
      const review = new Review(updatedReview);
      return Promise.resolve(review);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async deleteReview(id: string): Promise<any> {
    const url = this.serverConfig.ReviewAPIs.deleteReviewAPI(id);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makeDeleteRequest(authHeaders, url, {});
      return Promise.resolve(response.data);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  public async getAverageRatingForGigAPI(gigId: string): Promise<number> {
    const url = this.serverConfig.ReviewAPIs.getAverageRatingForGigAPI(gigId);
    const authHeaders = this.networkUtils.addAuthHeaders({});

    try {
      const response = await this.apiHandler.makeGetRequest(authHeaders, url);
      const { averageRating } = response.data;
      return Promise.resolve(averageRating);
    } catch (err) {
      return Promise.reject(err);
    }
  }
}